<template>
  <div class="home-footer">
    <div class="flex-row w-wrapper container">

      <div class="left">
        <div>
          <span>公司名称：天津豆画视界科技有限公司</span>
          <span class="arco-divider arco-divider-vertical"></span>
          <span>公司地址：天津市东丽区航双路与津滨快速路交口住所处东北侧航空商务中心7#-1,2,3,4,5,6,7-302,(3层-3501)</span>
        </div>
        <div>
          <span>网络文化经营许可证：津网文（2024）0161-025号</span>
          <span class="arco-divider arco-divider-vertical"></span>
          <span>广播电视节目制作经营：（津）字第1761号</span>
          <span class="arco-divider arco-divider-vertical"></span>
          <span>增值电信业务经营许可证：津B2-20240061</span>
        </div>
        <div class="flex-row-h-center">
          <span @click="goICP()" style="cursor: pointer;">互联网ICP备案：津ICP备2023009477号</span>
          <img src="@/assets/home/filing.png" alt="">
          <span @click="goGA()" style="cursor: pointer;">津公网安备 10086000000号</span>
        </div>
      </div>
      <div class="flex-row right">
        <el-popover
            placement="top"
            width="150"
            trigger="hover"
            v-model="visible">
          <div class="flex-center-row" style="width: 150px;">
            <canvas style="width: 150px;height: 150px;" ref="qrCanvas"></canvas>
          </div>
          <div class="flex-column app-item" slot="reference">
            <img src="@/assets/home/download.png" alt="">
            <span>下载APP</span>
          </div>
        </el-popover>
        <div @click="goWX()" class="flex-column app-item">
          <img src="@/assets/home/wechat.png" alt="">
          <span>官网微信</span>
        </div>
        <div v-if="false" class="flex-column app-item">
          <img src="@/assets/home/weibo.png" alt="">
          <span>新浪微博</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: "home-footer",
  methods: {
    goWX() {
      window.open('https://work.weixin.qq.com/kfid/kfc91e8d245a81f9193', '_blank')
    },
    goICP() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    },
    goGA() {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=10086000000', '_blank')
    }
  },
  mounted() {
    const qrContent = `https://douhuakj.cn/index`;
    try {
      // 清空 Canvas 并重新生成二维码
      QRCode.toCanvas(this.$refs.qrCanvas, qrContent, {width: 150}, (err) => {
        if (err) {
          console.error('生成二维码失败：', err);
        }
      });
    } catch (err) {
      console.error("二维码生成失败:", err);
    }
  },
}
</script>

<style lang="scss" scoped>
.home-footer {
  padding: 32px 130px;
  background: #f2f3f5;

  .container {
    margin: 0 auto;
    color: #86909c;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;

    .left {
      flex: 1;

      img {
        width: 20px;
        height: 20px;
        margin-left: 8px;
      }
    }

    .arco-divider-vertical {
      display: inline-block;
      min-width: 1px;
      max-width: 1px;
      height: 1em;
      margin: 0 12px;
      border-left: 1px solid rgb(229, 230, 235);
      vertical-align: middle;
    }

    .app-item {
      margin-left: 40px;
      cursor: pointer;

      img {
        width: 48px;
        height: 48px;
        margin-bottom: 4px;
      }
    }
  }
}
</style>